// WO-7/21 Track I: the checkbox-dropdown multi-select, modeled on the Domain filter pattern
// used across Find a Preprint / Find Reviewers ("Label: All ▾" summary + checkbox list).
export function MultiFilter({
  label,
  options,
  value,
  onChange,
}: {
  label: string;
  options: readonly string[];
  value: string[];
  onChange: (next: string[]) => void;
}): JSX.Element | null {
  if (options.length === 0) return null;
  const toggle = (opt: string): void =>
    onChange(value.includes(opt) ? value.filter((v) => v !== opt) : [...value, opt]);
  return (
    <details className="group relative">
      <summary className="cursor-pointer list-none rounded-md border border-slate-200 bg-white px-3 py-1.5 text-sm text-slate-700 hover:bg-slate-50">
        {label}: {value.length ? value.join(", ") : "All"}
      </summary>
      <div className="absolute right-0 z-40 mt-1 max-h-72 min-w-[12rem] overflow-auto rounded-md border border-slate-200 bg-white p-2 shadow-lg">
        {/* Angel (Stef mtg 8/20): one-click select/deselect all at the top of the list. */}
        <div className="mb-1 flex items-center justify-between gap-3">
          <p className="text-xs font-medium text-slate-500">Select one or more</p>
          <div className="flex gap-2">
            <button type="button" className="text-xs text-brand hover:underline" onClick={() => onChange([...options])}>
              Select all
            </button>
            <button type="button" className="text-xs text-brand hover:underline" onClick={() => onChange([])}>
              Deselect all
            </button>
          </div>
        </div>
        {options.map((opt) => (
          <label key={opt} className="flex cursor-pointer items-center gap-2 rounded px-1 py-0.5 text-sm hover:bg-slate-50">
            <input type="checkbox" checked={value.includes(opt)} onChange={() => toggle(opt)} />
            <span>{opt}</span>
          </label>
        ))}
      </div>
    </details>
  );
}
